import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeScreenB } from './navigation.action'
import { changeNotify } from './notify.action'
import { changeAlert } from './alert.action'

export const actionTypes = {
    INDEX: 'LINKS_INDEX',
    CHART: 'LINKS_CHART',
    STORE: 'LINKS_STORE',
    UPDATE: 'LINKS_UPDATE',
    DESTROY: 'LINKS_DESTROY',
    CHANGE: 'LINKS_CHANGE',
    SUCCESS: 'LINKS_SUCCESS',
    ERROR: 'LINKS_ERROR'
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

export const success = (payload) => ({
    type: actionTypes.SUCCESS,
    payload
})

export const error = (payload) => ({
    type: actionTypes.ERROR,
    payload
})

// INDEX 

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (query, isLoadMore) => dispatch => {
    return HttpAuth.get('/links?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data, isLoadMore)))
}

// CHART 
export const chartResponse = (payload) => ({
    type: actionTypes.CHART,
    payload
})

export const chartGeneralPeriod = (query) => dispatch => {
    return HttpAuth.post('/links/chart/general/period?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({period: res.data})))
}

export const chartGeneralHourly = (query) => dispatch => {
    return HttpAuth.post('/links/chart/general/hourly?'+ new URLSearchParams(query))
        .then(res => typeof res !== 'undefined' && dispatch(chartResponse({hour: res.data})))
}

// STORE

export const store = (data) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true
    }))

    return HttpAuth.post('/links', data)
    .then(res => {
        if(typeof res !== 'undefined') {
            if(res.data.success === 200) {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
                dispatch(change('clear'))
                dispatch(index({campaign_id: data.campaign_id})).then(e => dispatch(changeLoading({ open: false })))
                dispatch(success(true))
                dispatch(changeScreenB({ open: false }))
            }
        }
    })
    .catch(erro => {
        if(erro.response) {
            if(erro.response.data.msg) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: 'error'
                }))
            }
        }
        dispatch(changeLoading({ open: false }))
    })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/links/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(erro => {
            if(erro.response) {
                dispatch(changeNotify({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class
                }))
                dispatch(success(true))
            }
        })
}

// TEST

export const test = (pixel, access_token) => dispatch => {
    dispatch(changeLoading({ open: true }))

    return HttpAuth.post('/links/test', {
        'pixel': pixel,
        'access_token': access_token
    })
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                }
            }
        })
        .catch(erro => {
            dispatch(changeLoading({ open: false }))

            if(erro.response) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: erro.response.data.class,
                    time: 10000
                }))
            }
        })
}

// UPDATE

export const updateResponse = (payload) => ({
    type: actionTypes.UPDATE,
    payload
})

export const update = (data) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        block: true
    }))

    return HttpAuth.put('/links/'+data.id, data)
        .then(res => {
            dispatch(changeLoading({ open: false }))

            if(typeof res !== 'undefined') {
                if(res.data.success === 200) {
                    dispatch(changeNotify({
                        open: true,
                        msg: res.data.msg,
                        class: 'success'
                    }))
                    dispatch(index({campaign_id: data.campaign_id}))
                    dispatch(success(true))
                    dispatch(changeScreenB({ open: false }))
                }
            }
        })
        .catch(erro => {
            if(erro.response) {
                if(erro.response.data.msg) {
                    dispatch(changeAlert({
                        open: true,
                        msg: erro.response.data.msg,
                        class: 'error'
                    }))
                }
            }
            dispatch(changeLoading({ open: false }))
        })
}

// DESTROY

export const destroyResponse = (payload) => ({
    type: actionTypes.DESTROY,
    payload
})

export const destroy = (id) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        msg: 'Apagando...'
    }))

    return HttpAuth.delete('/links/'+ id)
        .then(res => {
            dispatch(changeLoading({ open: false, msg: 'Carregando...' }))
            if(typeof res !== 'undefined') {
                dispatch(destroyResponse(id))
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
            }
        })
}